/**
 * Initialize dropdown on the document
 *
 */

export default function dropdownInit() {
  const elements = document.querySelectorAll('.js-dropdown')

  elements.forEach((dropdown) => {
    const title = dropdown.querySelector('.js-dropdown-title')
    // const content = dropdown.querySelector('.js-dropdown-content')

    title.addEventListener('click', (e) => {
      e.preventDefault()
      dropdown.classList.toggle('open')

      elements.forEach((_dropdown) => {
        dropdown !== _dropdown ? _dropdown.classList.remove('open') : [];
      })
    })
  })
}
